export const CHAT_THINKING_PULSE_KEYFRAMES = [
  "@keyframes nc-thinking-pulse {",
  "  0%, 100% { transform: scale(1); opacity: 1; }",
  "  50% { transform: scale(1.25); opacity: 0.6; }",
  "}",
].join("\n");

export const CHAT_THINKING_PULSE_ANIMATION = "nc-thinking-pulse 1.4s ease-in-out infinite";
